import {
  ChartNoAxesCombined,
  Gem,
  Group,
  Package,
  Palette,
  SquarePlay,
  SunMoon,
} from "lucide-react";
import { AppearanceInspector } from "src/components/WidgetStudio/Inspector/inspectors/Appearance";
import { FunctionsInspector } from "src/components/WidgetStudio/Inspector/inspectors/Functions";
import { ColorsInspector } from "@app/components/WidgetStudio/Inspector/inspectors/Colors";
import { PostingInspector } from "@app/components/WidgetStudio/Inspector/inspectors/Posting";
import { GroupInspector } from "@app/components/WidgetStudio/Inspector/inspectors/Group";
import { ProductsInspector } from "@app/components/WidgetStudio/Inspector/inspectors/Products";
import { MarketingInspector } from "@app/components/WidgetStudio/Inspector/inspectors/Marketing";

export interface TabItem {
  type: "item";
  id: string;
  label: string;
  icon: any;
  description?: string;
  content?: any;
  autoScroll?: boolean;
}

interface TabSeparator {
  type: "separator";
}

export type InspectorTabItem = TabItem | TabSeparator;

export const InspectorTabs: Array<InspectorTabItem> = [
  {
    type: "item",
    id: "basic",
    label: "모양",
    icon: Gem,
    autoScroll: true,
    content: AppearanceInspector,
  },
  {
    type: "item",
    id: "colors",
    label: "색상",
    icon: Palette,
    autoScroll: true,
    content: ColorsInspector,
  },
  {
    type: "item",
    id: "advanced",
    label: "기능",
    icon: SunMoon,
    autoScroll: true,
    content: FunctionsInspector,
  },
  {
    type: "separator",
  },
  {
    type: "item",
    id: "posting",
    label: "포스팅",
    icon: SquarePlay,
    autoScroll: false,
    content: PostingInspector,
  },
  {
    type: "item",
    id: "groups",
    label: "포스팅 그룹",
    autoScroll: false,
    icon: Group,
    content: GroupInspector,
  },
  {
    type: "item",
    id: "products",
    label: "상품",
    autoScroll: false,
    icon: Package,
    content: ProductsInspector,
  },
  {
    type: "separator",
  },
  {
    type: "item",
    id: "measurement",
    label: "마케팅",
    autoScroll: true,
    icon: ChartNoAxesCombined,
    content: MarketingInspector,
  },
];
